import DetailObjective from "./Details";
import ListObjective from "./List";

export { DetailObjective, ListObjective };
